import React from 'react';
import css from './css.module.less';

import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ExpandTable from './ProductTable';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { EnumTablePosition } from 'src/types/common/common';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import EditableTable from 'src/components/Antd/Table/SizeFittingTable';
import { request_productList } from 'src/request/salesChannel/product';
import { CircleTags } from '@/src/components/Antd/Tag/Tag';
import { salesChannelType } from 'src/tools/constant';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

const SalesChannelAvailability = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const p: any = useParams();
  const { uuid: productUuid } = p;

  const { data = [], onProductsAdd, onProductDelete, disabled } = props;

  //const products = useSelector((state) => state.productSet.products);

  const columns = React.useMemo(() => {
    return [
      {
        title: getI18n('general.status'),
        key: 'icon',
        childGenerate: (text, record, index) => {
          return (
            <CircleTags color='success'>
              {getI18n('general.published')}
            </CircleTags>
          );
        },
        width: 88,
        default: true,
        //className: css.colTest,
      },
      {
        title: getI18n(
          'allProducts.addproductset.salesChannelAvailability_component_AvailableTable',
        ),
        childGenerate: (text, record, index) => {
          const { name } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={name}>{name}</Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'salesChannelName',
        minWidth: 503,
        default: true,
        // className: css.colTest,
      },
      {
        title: getI18n('general.type'),
        childGenerate: (text, record, index) => {
          const { channelType } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={channelType}>
                {salesChannelType[channelType]}
              </Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'Type',
        minWidth: 400,
        default: true,
        percentage: 9,
      },
      {
        title: <React.Fragment />,
        position: EnumTablePosition.mid,

        childGenerate: (text, record, index) => {
          return <React.Fragment />;
        },
        key: 'salesChannelActions',
        width: 180,
        default: true,
      },
    ];
  }, []);
  const requestSubProducts = (uuid: string) => {
    request_productList(uuid, 0, 99999, {
      productUuids: [productUuid],
    }).then((res) => {
      if (onProductsAdd) {
        const _products = res.results.map((i) => {
          return {
            productName: i.productName,
            productType: i.productType,
            uuid: i.uuid,
            thumbnailUrl: i.thumbnailUrl,
            valid: i.valid,
          };
        });
        onProductsAdd({ uuid, products: _products });
      }
    });
  };
  const advancedPricingExpandFunction = {
    expandedRowRender: (record, index, ...rest) => {
      const { products = [], key, uuid } = record || {};
      if (products && products.length > 0) {
        return (
          <ExpandTable
            disabled={disabled}
            data={products}
            keyProps={key}
            parentIndex={index}
            productUuid={productUuid}
            salesChannelUuid={uuid}
            onDelete={onProductDelete}
          />
        );
      }
      return <div />;
    },
    onExpand: (expanded, record) => {
      const { products, uuid } = record;
      if (expanded && !products) {
        requestSubProducts(uuid);
      }
    },
    rowExpandable: () => {
      return true;
    },
    expandedRowClassName: () => {
      return css.rowExpandContainer;
    },
    expandIcon: ({ expanded, onExpand, record }) =>
      expanded ? (
        <DownOutlined onClick={(e) => onExpand(record, e)} />
      ) : (
        <UpOutlined onClick={(e) => onExpand(record, e)} />
      ),
  };
  const tableProps = {
    // rowClassName: (record, index) => {
    //   if (record.open) {
    //     return css.noBorderBottom;
    //   }
    // },
    expandable: advancedPricingExpandFunction,
  };

  return (
    <ItemWrapper
      bottomTitle={replaceI18nVariables(
        getI18n(
          'allProducts.addproductset.salesChannelAvailability_component_AvailableTable_bottomtitle',
        ),
        '4',
      )}>
      <div className={css.tipContainer}>
        {replaceI18nVariables(
          getI18n(
            'allProducts.addproductset.salesChannelAvailability_component_AvailableTable_bottomtitle',
          ),
          data.length || 0,
        )}
      </div>
      <EditableTable
        rowKey={'uuid'}
        pagination={false}
        dataSource={data}
        columns={columns}
        id='ProductEditorAvailabilityTable'
        {...tableProps}
        //rowKey={'uuid'}
      />
    </ItemWrapper>
  );
};
export default SalesChannelAvailability;
